export * from './ColorPalette';
export { default } from './ColorPalette';
